import es from '@vueform/vueform/locales/es'
import en from '@vueform/vueform/locales/en'
import pt_BR from '@vueform/vueform/locales/pt_BR'
import vueform from '@vueform/vueform/dist/vueform'
import { defineConfig } from '@vueform/vueform'
import VueformDatepicker from '@/components/vuetify-extensions/vueform/VueformDatepicker.vue'
import CustomSelectElement from '@/components/vuetify-extensions/vueform/VueformCombobox.vue'
import CustomMultiSelectElement from '@/components/vuetify-extensions/vueform/VueformMultiCombobox.vue'
import CustomFileToComplete from '@/components/vuetify-extensions/vueform/VueformFileToComplete.vue'
import CustomMultilineElement from '@/components/vuetify-extensions/vueform/VueformMultiline.vue'
import VueformSignature from '@/components/vuetify-extensions/vueform/VueformSignature.vue'
// @ts-ignore
import PluginMask from '@vueform/plugin-mask'

// You might place these anywhere else in your project
import '@vueform/vueform/dist/material.css';

export default defineConfig({
  theme: vueform,
  locales: { es, en, 'pt-BR': pt_BR },
  locale: localStorage.getItem('locale') || 'es',
  size: "sm",
  plugins: [
    PluginMask,
  ],
  elements: [
    VueformDatepicker, CustomSelectElement, CustomMultiSelectElement, CustomFileToComplete, CustomMultilineElement, VueformSignature
  ],
  endpoints: {
    uploadTempFile: (async (file: File, el$: any) => {
      const { Api } = await import('@/utils/api')
      const formData = new FormData()
      formData.append("file", file)

      let result: any
      await Api.post(
        "accountability/cloud-file-service/upload/",
        formData,
        () => {},
        (response: any) => { result = response.data },
        () => {}
      )
      return result.url
    }) as any,
  },
})
